'use strict';
/**
 * ═══════════════════════════════════════════════════════════════════════════
 *  mdb-gunlestirme — Excel seri numarası artefaktını OKUMA ANINDA geri alır
 *  Şema v0.28 §9.6.1 · Modül sürümü v1.0.0 · 2 Eylül 2026
 * ═══════════════════════════════════════════════════════════════════════════
 *
 * NEDEN AYRI BİR DOSYA — bu dosyanın tek varlık sebebi budur, okumadan taşıma:
 *
 * Artefaktı üreten şey `xlsx`in seri numarasını OKUYAN SÜRECİN yerel dilimiyle
 * Date'e çevirmesidir. Geri almak için gereken bilgi (okuyan sürecin dilimi)
 * YALNIZCA okuma anında vardır. Bu yüzden düzeltme okuyanın yanında koşmak
 * zorunda. Okuyanlar ÜÇ TANE:
 *
 *     1) göç script'i (CLI, Node)          → import-influencers.js
 *     2) sunucu yükleme akışı (Node)       → server.js
 *     3) PANEL — TARAYICI (CRA paketi)     → MasterDatabasePage.js · taslakAyristir
 *
 * Üçüncüsü mdb-tarama.js'i IMPORT EDEMEZ:
 *   · mdb-tarama.js, SAGLAMA'yı hesaplamak için require('fs') + require('crypto')
 *     çağırır (modül yüklenirken, tembel değil);
 *   · ve satır 54'te mdb-birlestirme.js'i çeker — o da AYNI ikiliyi çağırır ve
 *     DONDURULMUŞ bir dosyadır (200a73340e0395d6), dokunulamaz.
 * Yani yalnız mdb-tarama'yı düzeltmek yetmezdi: bağımlılık zinciri gene fs'e
 * çıkardı. Ölçüldü — webpack 5 dört "Module not found" uyarısı verir, CI=true
 * altında bunlar HATAYA döner; hata dönmediği durumda ise try/catch yutar ve
 * SAGLAMA sessizce 'okunamadi' olur, yani KAPI TARAYICIDA KENDİLİĞİNDEN AÇILIR.
 * Bir korumanın ters yönde çalışmasının bir başka örneği olurdu.
 *
 * BU DOSYANIN KURALI: sıfır bağımlılık. fs yok, crypto yok, xlsx yok,
 * mdb-birlestirme yok, __filename yok. Yalnız saf JavaScript. Bir paketleyiciye
 * girdiğinde uyarı üretmez ve ~1 KB yer kaplar.
 *
 * SAĞLAMA KAPISI — bu dosya KENDİ sha256'sını HESAPLAMAZ (crypto gerekirdi ve
 * kural bozulurdu). Kapı testte: test-parsers.js dosyanın sha256'sını okuyup
 * sabit bir beklentiyle karşılaştırır — mapping-profiles.json ile birebir aynı
 * desen. Kapı zayıflamaz: iki kopya da (frontend/lib ve persona-mdb-migration)
 * kendi yanındaki testle aynı sabite kilitlenir.
 *
 * KOPYA YAZMAK YASAK: mdb-tarama.js bu dosyayı require eder ve
 * `satirlariGunlestir`ı olduğu gibi yeniden dışa verir. Tanım TEKTİR.
 *
 * PAY: gece yarısına 5 dakika, İKİ YÖNDE. Ölçülen sapmalar —
 * UTC/NY/Tokyo/London/LA/Auckland 0 sn · Kolkata −10 · Dubai −12 · Tahran −44 ·
 * İstanbul −56. Hepsi bir dakikanın altında; 5 dk beş kattan fazla pay bırakır.
 * Pencerenin dışındaki bir Date GERÇEK an sayılır (form başvuru damgası) ve
 * DOKUNULMAZ — onun iş günü şema §3.11'e göre ayrıştırma tarafında çözülür.
 */

const SURUM = 'v1.0.0';

const GUNLESTIRME_PAYI_MS = 5 * 60 * 1000;

/**
 * Bir Date'in gün dizgesi ('YYYY-MM-DD') — YEREL dilime göre.
 * Gece yarısına 5 dk'dan yakınsa (iki yönde de) artefakt sayılıp o güne yapışır.
 * Gerçek an ise `null` döner: çağıran Date'i olduğu gibi bırakır.
 */
function gunDizgesi(d) {
  const giMs = ((d.getHours() * 60 + d.getMinutes()) * 60 + d.getSeconds()) * 1000 + d.getMilliseconds();
  let r = d;
  if (giMs >= GUNLESTIRME_PAYI_MS) {
    if (giMs <= 86400000 - GUNLESTIRME_PAYI_MS) return null;   // gerçek an — dokunma
    r = new Date(+d + GUNLESTIRME_PAYI_MS);                    // gece yarısına yapışık
  }
  const ay = String(r.getMonth() + 1).padStart(2, '0');
  const gun = String(r.getDate()).padStart(2, '0');
  return `${r.getFullYear()}-${ay}-${gun}`;
}

/**
 * Satır dizisindeki (aoa) Date hücrelerini okuyan dilimde güne indirir.
 * Girdiyi DEĞİŞTİRMEZ; yeni dizi döner. `{ satirlar, gunlesen, bozulmayan }`.
 *
 * Çağrı yeri: dosya OKUNDUKTAN hemen sonra, satırlar başka hiçbir yere
 * gitmeden. CLI'de readSheetRows içinde; tarayıcıda XLSX.utils.sheet_to_json
 * çıktısı üzerinde, sunucuya POST edilmeden ÖNCE.
 */
function satirlariGunlestir(satirlar) {
  let gunlesen = 0, bozulmayan = 0;
  const cikti = (satirlar || []).map((satir) => {
    if (!Array.isArray(satir)) return satir;
    return satir.map((h) => {
      if (!(h instanceof Date) || isNaN(h)) return h;
      const g = gunDizgesi(h);
      if (g) { gunlesen++; return g; }
      bozulmayan++; return h;
    });
  });
  return { satirlar: cikti, gunlesen, bozulmayan };
}

module.exports = { SURUM, GUNLESTIRME_PAYI_MS, gunDizgesi, satirlariGunlestir };
